import type { ApiError } from '@services/ApiClient'

export class CooperativeMembershipConflictError extends Error {
  readonly shareholderName: string
  readonly cause: ApiError

  constructor(shareholderName: string, cause: ApiError) {
    super(cause.message)
    this.name = 'CooperativeMembershipConflictError'
    this.shareholderName = shareholderName
    this.cause = cause
  }
}

export class CooperativeMembershipCancelledError extends Error {
  constructor() {
    super('User cancelled cooperative membership transfer')
    this.name = 'CooperativeMembershipCancelledError'
  }
}

export class CooperativeMembershipLookupError extends Error {
  readonly cause?: unknown

  constructor(message?: string, cause?: unknown) {
    super(message ?? 'Cooperative membership lookup failed')
    this.name = 'CooperativeMembershipLookupError'
    this.cause = cause
  }
}
